import { Injectable } from '@angular/core';

import { HttpClientService } from '../../../shared/services/http-client.service';

import { Allocation } from '../../models/allocation'


@Injectable()
export class ReportsService {

  constructor(
    private httpService: HttpClientService,
  ) { }

  getEmployeeAllocation(body: any) {
    return this.httpService.post('admin/reports/allocation', body);
  }

  getTimeAllocation(body: any) {
    return this.httpService.post('admin/reports/timespent', body);
  }

  getResourceAvailability(body: any) {
    return this.httpService.post('admin/reports/resourceavailability', body);
  }

  getIncome(body: any) {
    return this.httpService.post('admin/reports/income', body);
  }

  getResourceAvailabilityFormData() {
    return this.httpService.get('admin/reports/formdata');
  }

  getTimeSheetAndAttendanceByDate(body: any) {
    return this.httpService.post('admin/reports/attendanceTime', body);
  }

  getTimeSheetAndAttendanceWithOutShorting(body: any) {
    return this.httpService.post('admin/reports/attendanceTimeWithOutShorting', body);
  }
  getTimeSheetAndAttendanceForMyChart(body: any) {
    return this.httpService.post('admin/reports/attendanceTimeForMyChart', body);
  }
  getTimeSheetAndAttendanceForMyChartShortingMonth(body: any) {
    return this.httpService.post('admin/reports/attendanceTimeForMyChartShortingMonth', body);
  }
  

}



// WEBPACK FOOTER //
// ./src/app/modules/reports/services/reports.service.ts